import React, { useEffect } from "react";
function Footer() {
  const ThemeChecker = () => {
    // Enable user selection of color scheme

    // Check for stored preference
    const themePrefKey = "theme-pref";

    const getStoredThemePref = function () {
      const storedThemePref = localStorage.getItem(themePrefKey);
      if (storedThemePref) {
        return storedThemePref;
      } else {
        return "auto";
      }
    };

    // Apply stored preference
    const storedThemePref = getStoredThemePref();

    document.documentElement.setAttribute(
      "data-prefers-theme",
      storedThemePref,
    );

    // Set new preference
    const setThemePref = function (themeValue) {
      document.documentElement.setAttribute("data-prefers-theme", themeValue);

      localStorage.setItem(themePrefKey, themeValue);
    };
    // Wait until document is parsed
    useEffect(() => {
      // Check radio according to stored pref
      document
        .getElementById("theme-radio-" + storedThemePref)
        .setAttribute("checked", "");

      // Switch preference
      const themeRadios = document.querySelectorAll("[name=theme]");
      themeRadios.forEach(function (themeRadio) {
        themeRadio.addEventListener("change", function () {
          if (themeRadio.checked) {
            const themeValue = themeRadio.getAttribute("value");
            setThemePref(themeValue);
          }
        });
      });
    }, [storedThemePref]);
  };
  ThemeChecker();

  const d = new Date();
  let year = d.getFullYear();
  return (
    <section>
      <footer className="l-section | site-footer">
        <div className="l-contain l-contain--flush l-grid l-grid--flush l-grid--thirds | site-footer__content">
          <nav
            aria-labelledby="footer-nav-heading"
            className="site-footer__section site-footer__nav">
            <h2 id="footer-nav-heading">Navigation</h2>
            <div className="site-footer__section-content">
              <ul className="u-simple-list | site-footer__nav-list">
                <li>
                  <a href="#main">Home</a>
                </li>
                <li>
                  <a href="#product">
                    <span>Project</span>
                  </a>
                </li>

                <li>
                  <a href="#info">
                    <span>Info</span>
                  </a>
                </li>
                <li>
                  <a href="#nuggets">
                    <span>Nuggets</span>
                  </a>
                </li>
              </ul>
            </div>
          </nav>
          <div className="site-footer__section site-footer__contact">
            <h2>Contact</h2>
            <div className="site-footer__section-content">
              <ul className="u-simple-list | c-social-links">
                <li>
                  <a
                    href="https://substack.com/profile/94557965-ayomide-alajogun"
                    target="_blank"
                    rel="noopener noreferrer">
                    <svg
                      focusable="false"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="24"
                      height="24">
                      <title>Substack</title>
                      <path
                        d="M22.539 8.242H1.46V5.406h21.08v2.836zM1.46 10.812V24L12 18.11 22.54 24V10.812H1.46zM22.54 0H1.46v2.836h21.08V0z"
                        fillRule="evenodd"></path>
                    </svg>
                  </a>
                </li>
                <li>
                  <a
                    href="https://twitter.com/_blackaroni_"
                    target="_blank"
                    rel="noopener noreferrer">
                    <svg
                      focusable="false"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 248 204"
                      width="24"
                      height="24">
                      <title>Twitter</title>

                      <path
                        d="M221.95,51.29c0.15,2.17,0.15,4.34,0.15,6.53c0,66.73-50.8,143.69-143.69,143.69v-0.04
		C50.97,201.51,24.1,193.65,1,178.83c3.99,0.48,8,0.72,12.02,0.73c22.74,0.02,44.83-7.61,62.72-21.66
		c-21.61-0.41-40.56-14.5-47.18-35.07c7.57,1.46,15.37,1.16,22.8-0.87C27.8,117.2,10.85,96.5,10.85,72.46c0-0.22,0-0.43,0-0.64
		c7.02,3.91,14.88,6.08,22.92,6.32C11.58,63.31,4.74,33.79,18.14,10.71c25.64,31.55,63.47,50.73,104.08,52.76
		c-4.07-17.54,1.49-35.92,14.61-48.25c20.34-19.12,52.33-18.14,71.45,2.19c11.31-2.23,22.15-6.38,32.07-12.26
		c-3.77,11.69-11.66,21.62-22.2,27.93c10.01-1.18,19.79-3.86,29-7.95C240.37,35.29,231.83,44.14,221.95,51.29z"
                      />
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    target="_blank"
                    rel="noopener noreferrer"
                    href="https://medium.com/@alajogunayomide">
                    <svg
                      focusable="false"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 16 16"
                      width="24"
                      height="24">
                      <title>Medium</title>
                      <path d="M9.025 8c0 2.485-2.02 4.5-4.513 4.5A4.506 4.506 0 0 1 0 8c0-2.486 2.02-4.5 4.512-4.5A4.506 4.506 0 0 1 9.025 8zm4.95 0c0 2.34-1.01 4.236-2.256 4.236-1.246 0-2.256-1.897-2.256-4.236 0-2.34 1.01-4.236 2.256-4.236 1.246 0 2.256 1.897 2.256 4.236zM16 8c0 2.096-.355 3.795-.794 3.795-.438 0-.793-1.7-.793-3.795 0-2.096.355-3.795.794-3.795.438 0 .793 1.699.793 3.795z"></path>
                    </svg>
                  </a>
                </li>

                <li>
                  <a
                    href="https://www.linkedin.com/in/ayomide-alajogun/"
                    target="_blank"
                    rel="noopener noreferrer">
                    <svg
                      focusable="false"
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 32 32"
                      width="24"
                      height="24">
                      <title>LinkedIn</title>
                      <path d="M27.26 27.27h-4.73v-7.43c0-1.77-.04-4.05-2.48-4.05s-2.84 1.92-2.84 3.92v7.56h-4.74V12h4.55v2.08h.06c.64-1.2 2.18-2.47 4.49-2.47 4.8 0 5.69 3.16 5.69 7.27v8.39ZM7.11 9.91c-1.53 0-2.75-1.23-2.75-2.76S5.59 4.4 7.11 4.4s2.76 1.23 2.76 2.75-1.23 2.76-2.76 2.76Zm2.37 17.36H4.74V12h4.75v15.27ZM29.64 0H2.36C1.06 0 0 1.03 0 2.31v27.38C0 30.97 1.06 32 2.36 32h27.27c1.3 0 2.37-1.03 2.37-2.31V2.31C32 1.03 30.93 0 29.63 0Z"></path>
                    </svg>
                  </a>
                </li>
              </ul>
            </div>
          </div>
          <div className="site-footer__section site-footer__info">
            <h2>Site Info</h2>
            <div className="site-footer__section-content">
              <p className="c-supporting-text">
                © {year} Ayomide Alajogun. <br /> Inspired by{" "}
                <a
                  target="_blank"
                  rel="noopener noreferrer"
                  href="https://github.com/melanierichards/">
                  Melanie Richards
                </a>
              </p>
              <fieldset className="theme-switcher">
                <legend>Theme</legend>
                <div className="theme-switcher__options">
                  <span className="theme-switcher__option">
                    <input
                      id="theme-radio-auto"
                      type="radio"
                      name="theme"
                      value="auto"
                    />
                    <label htmlFor="theme-radio-auto">Auto</label>
                  </span>
                  <span className="theme-switcher__option">
                    <input
                      id="theme-radio-light"
                      type="radio"
                      name="theme"
                      value="light"
                    />
                    <label htmlFor="theme-radio-light">Light</label>
                  </span>
                  <span className="theme-switcher__option">
                    <input
                      id="theme-radio-dark"
                      type="radio"
                      name="theme"
                      value="dark"
                    />
                    <label htmlFor="theme-radio-dark">Dark</label>
                  </span>
                </div>
              </fieldset>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}

export default Footer;
